/**
 * @Description 商圈详情-基本信息栏
 */

import { FC, useMemo } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import { isNotEmpty } from '@lhb/func';
import { fixNumber } from '@/common/utils/ways';

interface BisConType {
  title:string;
  value:any;
  tag?:string
}

const Basic: FC<any> = ({
  overView
}) => {
  // console.log('===Basic detail:', detail, 'overview:', overView);

  const populationStr = (count) => {
    if (!isNotEmpty(count)) return '-';
    return +count >= 10000
      ? `${fixNumber(count / 10000, 1)}万人`
      : `${Math.floor(count)}人`;
  };

  const population500mShow = (data: any) => {
    return {
      title: '500m居住人口',
      value: populationStr(data?.population),
    };
  };
  const population1500mShow = (data: any) => {
    return {
      title: '1.5km居住人口',
      value: populationStr(data?.population1500m),
    };
  };
  const population500mWorkShow = (data: any) => {
    return {
      title: '500m工作人口',
      value: populationStr(data?.populationWork500m),
    };
  };
  const population1500mWorkShow = (data: any) => {
    return {
      title: '1.5km工作人口',
      value: populationStr(data?.populationWork1500m),
    };
  };
  const residentPopulationShow = (data: any) => {
    return {
      title: '500m常驻人口',
      value: populationStr(data?.residentPopulation500m),
    };
  };
  const residentPopulation1500mShow = (data: any) => {
    return {
      title: '1.5km常驻人口',
      value: populationStr(data?.residentPopulation1500m),
    };
  };

  const firstRow = useMemo((): BisConType[] => {
    return [
      population500mShow(overView),
      population1500mShow(overView),
      population500mWorkShow(overView),
    ];
  }, [overView]);

  const secondRow = useMemo((): BisConType[] => {
    return [
      population1500mWorkShow(overView),
      residentPopulationShow(overView),
      residentPopulation1500mShow(overView),
    ];
  }, [overView]);

  return (
    <div className={styles.basicContainer}>
      <div className={styles.row}>
        {firstRow.map((itm, idx) => <div key={idx} className={cs(styles.cateCon, idx && 'ml-4')}>
          <div className={cs('fs-14 c-222', styles.value)}>{itm?.value}</div>
          <div className='fs-12 c-999 mt-4'>{itm?.title}</div>
        </div>)}
      </div>
      <div className={cs(styles.row, 'mt-4')}>
        {secondRow.map((itm, idx) => <div key={idx} className={cs(styles.cateCon, idx && 'ml-4')}>
          <div className={cs('fs-14 c-222', styles.value)}>{itm?.value}</div>
          <div className='fs-12 c-999 mt-4'>{itm?.title}</div>
        </div>)}
      </div>
    </div>
  );
};

export default Basic;
